const RoleManagementStyles = {
  pageSubtitle: {},
  addTagChip: {
    marginLeft: "5px",
    marginTop: "8px",
    borderRadius: "5px",
    fontSize: "15px",
    backgroundColor: "#fcf5ff",
  },
  resourceRowHeader: {
    fontSize: "16px",
  },
  placeholderText: {
    color: "#999999",
  },
  resourceActionButton: {
    background: "#FFFFFF",
    borderRadius: "10px",
    width: "100%",
    height: "45px",
    border: "1px solid #E7E7E7",
  },
  dropDownStyle: {
    backgroundColor: "#FFFFFF",
    height: "47px",
    padding: "2px",
    width: "100%",
    borderRadius: "12px",
    fontSize: "16px",
  },
  errorText: {
    color: "#d32f2f",
    paddingLeft: "10px",
  },
  optionStyle: {
    //
    // ...pinkThemedMenuItems,
  },
  predefinedGridContainer: {
    display: "grid",
    gridColumnGap: "20px",
    gridRowGap: "20px",
    marginTop: "20px",
    gridTemplateColumns: "repeat(3, 1fr)",
  },
  predefinedTooltipContent: {
    padding: "10px",
    color: "white",
    fontSize: "14px",
    //
  },
  predefinedGridItem: {
    background: "#FFFFFF",
    border: "1px solid #E7E7E7",
    borderRadius: "8px",
    padding: "20px",
    cursor: "pointer",
  },
  predefinedRoleName: {
    fontSize: "20px",
    fontWeight: 600,
    fontStyle: "normal",
    color: "#000000",
    textTransform: "capitalize",
  },
  predefinedListStyle: {
    listStyleType: "disc",
    padding: "10px 1px 10px 30px",
  },
  predefinedListItem: {
    paddingLeft: "0px",
    fontSize: "14px",
    fontStyle: "normal",
    color: "#475569",
    textTransform: "capitalize",
    display: "list-item",
    lineHeight: "23px",
    "::marker": {
      color: "#475569",
    },
  },
  centerItemFlex: {
    paddingBottom: "15px",
  },
  pageFooter: {
    display: "flex",
    gap: "10px",
    width: "100%",
    justifyContent: "center",
  
  },
  cancelButtonStyle: {
    color: "#212121 !important",
    backgroundColor: "#FFFFFF",
    border: "1px solid #E7E7E7",
    "&:hover": {
      background: "none",
    },
  },
  dialogTitleWrapper: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
    gap: "10px",
    textAlign: "center",
  },
  titleRight: {
    color: " rgba(0,0,0,.85)",
  },
  dialogContent: {
    textAlign: "center",
    "& span": {},
  },
  dialogFooter: {
    width: "100%",
    display: "flex",
    alignItem: "center",
    justifyContent: "center",
    marginBottom: "20px",
    gap: "10px",
    "& button": {
      width: "120px",
    },
  },
  buttonWhiteBg: {
    background: "none",
    border: "1px solid",
    // borderColor: buttonWhiteBg,
    // color: purplePrimaryColor,
    "&:hover": {
      background: "none",
    },
  },
  campaignPerDefined: {
    display: "grid",
    gridColumnGap: "20px",
    gridRowGap: "20px",
    marginTop: "1px",
    gridTemplateColumns: "repeat(1, 1fr)",
    // [theme.breakpoints.only("xs")]: {
    //   gridTemplateColumns: "repeat(1, 1fr)",
    // },
    // [theme.breakpoints.only("sm")]: {
    //   gridTemplateColumns: "repeat(2, 1fr)",
    // },
    // [theme.breakpoints.only("md")]: {
    //   gridTemplateColumns: "repeat(3, 1fr)",
    // },
  },
  inputLabel: {
    color: "#475569",
    fontSize: "14px",
    flexShrink: 0,
    fontWeight: 500,
    mt: 2,
  }
} as const;

export default RoleManagementStyles;
